<template>
  <div class="popup">
    <div class="popup-bg" @click="close"></div>
    <div class="popup-tip j-popup-tip" v-bind:class="{good:goodType,bad:badType}">
      <p class="popup-tip-text">{{commonTips}}</p>
      <a href="javascript:;" @click="close" class="popup-close"></a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export const POPUP_STYLE = {
  good: Symbol(),
  bad: Symbol(),
};

export default {
  data() {
    return {};
  },
  methods: {
    close() {
      this.$store.commit("updateCommonTips", {
        msg: "",
        style: "",
      });
    },
  },
  computed: {
    goodType() {
      return this.commonTipsStyle === POPUP_STYLE.good;
    },
    badType() {
      return this.commonTipsStyle === POPUP_STYLE.bad;
    },
    ...mapGetters(["commonTips", "commonTipsStyle"]),
  },
};
</script>


<style lang="scss">
@import "../assets/scss/_mixins";
$imgURL: "../assets/img/";

$divide: 10 !default;
$pswWidth: 750;

.popup {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  bottom: 0;
  &-bg {
    background-color: black;
    opacity: 0.6;
    z-index: -1;
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
  }
  &-close {
    position: absolute;
    right: 10px;
    top: 20px;
    @include size(57px, 57px);
    background: url($imgURL + "x.png");
    background-size: contain;
  }
  &-tip {
    position: absolute;
    left: 50%;
    top: 40%;
    margin-left: -226px;
    margin-top: -110px;
    @include size(453px, 220px);
    &.good {
      background: url($imgURL + "good-gift-popup.png");
      background-size: contain;
    }
    &.bad {
      background: url($imgURL + "gift-popup.png");
      background-size: contain;
    }
    &-text {
      color: #706f6f;
      width: 235px;
      height: 95px;
      line-height: 130%;
      top: 104px;
      right: 32px;
      font-size: 18px;
      text-align: center;
      position: absolute;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TipPopUpIframe.vue